import { combineReducers } from "redux";
import cubeMgmtSlice from "store/cubeMgmt";
import layout from "./layoutReducer";
import cubeGroupsSlice from "store/cubeGroups";
import staticReports from "./staticReportsReducer";
import staticReportsSnowflakeSlice from "store/staticReportsSnowflake";
import psoResultsSlice from "store/psoResults";
import navigation from "./navigationReducer";
import dashboard from "./dashboardReducer";
import map from "./mapReducer";
import comparerDshbSlice from "store/comparerDshb";
import ThemeOptions from "./ThemeOptions";
import instanceMgrSlice from "store/instanceManager";
import accountMgmtSlice from "store/accountMgmt";
import projectMgmtSlice from "store/projectMgmt";
import taskMgmtSlice from "store/taskMgmt";
import scenarioMgmtSlice from "store/scenarioMgmt";
import scenarioStatusSlice from "store/scenarioStatus";
import enelytixBillingSlice from "store/enelytixBilling";
import logs from "./psoLogsReducer";
import scenarioGroups from "./scenarioGroupReducer";
import tagsSlice from "store/tags";
import otiManager from "./otiReducer";
import probes from "./probeReducer";
import resourceAdequacySlice from "store/resourceAdequacy";
import dashboardViewerSlice from "../store/dashboardViewer/reducer";
import dashboardMgmtSlice from "store/dashboardMgmt";
import oneLineDiagramSlice from "store/oneLineDiagram";

const rootReducer = () =>
    combineReducers({
        cubeMgmtSlice,
        layout,
        cubeGroupsSlice,
        staticReports,
        staticReportsSnowflakeSlice,
        navigation,
        psoResultsSlice,
        dashboard,
        map,
        comparerDshbSlice,
        ThemeOptions,
        instanceMgrSlice,
        accountMgmtSlice,
        projectMgmtSlice,
        taskMgmtSlice,
        scenarioMgmtSlice,
        scenarioStatusSlice,
        enelytixBillingSlice,
        logs,
        scenarioGroups,
        tagsSlice,
        probes,
        otiManager,
        resourceAdequacySlice,
        dashboardViewerSlice,
        dashboardMgmtSlice,
        oneLineDiagramSlice
    });

export default rootReducer;
